import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import HomePage from './pages/HomePage/HomePage.jsx';
import ProcessPage from './pages/ProcessPage/ProcessPage.jsx';
import ApplyPage from './pages/ApplyPage/ApplyPage.jsx';
import PrivacyPage from './pages/PrivacyPage/PrivacyPage.jsx';
import TermsPage from './pages/TermsPage/TermsPage.jsx';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </>
  );
}

export default App;
